//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import translateMesh from "./Translate.js";

export default {
  name: "Translate",
  props: {
    selected: {
      type: Array
    }
  },
  data() {
    return {
      offset: [0, 0, 0],
      range: 100,
      translatedMesh: undefined
    };
  },
  watch: {
    offset() {
      this.generate();
    }
  },
  methods: {
    generate() {
      this.translatedMesh = translateMesh(
        this.offset,
        this.selected[0].geometry
      );
      this.$emit("feature:preview", this.translatedMesh);
    }
  },
  mounted() {
    console.log("Translate Mounted");
    this.generate();
  }
};
